import { Col, Badge } from 'react-bootstrap';
import { Card } from '@pmi/dsm-react';
import { AlertSuccessSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import { HubAccountInviteSelectDto, HubAccountSelectDto } from './models';
import styles from '../../Admin/AccountSelect/accountselect.module.scss';

interface HubAccountSelectCardProps {
  accountUserId: string | null;
  selectedAccountUserId: string;
  accountDetails: HubAccountSelectDto;
  handleClick: (accountId: string) => void;
  inviteDetails?: HubAccountInviteSelectDto | null;
}

export default function HubAccountSelectCard({
  accountUserId,
  inviteDetails = null,
  selectedAccountUserId,
  accountDetails,
  handleClick,
}: HubAccountSelectCardProps) {
  return (
    <Col sm={6} md={4} lg={3} className="my-2 text-center" key={accountUserId}>
      <div
        className={`cursor-pointer h-100 ${
          selectedAccountUserId === accountUserId
            ? 'border border-dark border-2'
            : ''
        }`}
        aria-label={accountDetails.name}
        aria-checked={selectedAccountUserId === accountUserId}
        tabIndex={0}
        role="radio"
        onClick={() => handleClick(accountUserId)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleClick(accountUserId);
          }
        }}
      >
        <Card className={`${styles.accountCard} d-flex flex-column p-2 h-100`}>
          <div className="position-relative p-3 me-3">
            {selectedAccountUserId === accountUserId && (
              <AlertSuccessSolidIcon
                className="position-absolute end-0"
                color="success"
                fontSize="xs"
              />
            )}
          </div>
          <img
            className="m-auto mb-2 object-fit-contain"
            width="100"
            height="100"
            src={`${
              accountDetails.logoUrl ??
              'https://upload.wikimedia.org/wikipedia/commons/3/3f/Placeholder_view_vector.svg'
            } `}
            alt="placeholder"
          />
          <div className="mb-2">
            {inviteDetails && <Badge bg="warning">INVITATION</Badge>}
          </div>
          <h6>{accountDetails.name}</h6>
          <p className="small">
            {inviteDetails?.email && `Invitation for ${inviteDetails.email}`}
          </p>
        </Card>
      </div>
    </Col>
  );
}
